import { Box, Group } from '@web/components/atoms/Layout'
import LeaderboardGroup from './LeaderboardGroup'
import { Leaderboard as LeaderboardProps } from '@web/graphql-components'
import { ProfileData } from '@web/graphql-types'
import { SubComponentProps } from '../utils'
import { useColorWithOpacity } from '@web/components/molecules/ColorPicker/utils'
import { Input, InputGroup } from '@web/components/atoms/Input'
import { SearchIcon } from '@web/components/atoms/Icons'
import { useState } from 'react'

const Leaderboard = ({
  styles,
  data,
  mobileStyles,
  id,
  type,
  subComponents,
  SubComponent,
  isLoading,
  registerUrl,
  onSearch,
  ...rest
}: LeaderboardProps & {
  data: ProfileData[]
  isLoading?: boolean
  registerUrl?: string
  onSearch?: (value: string) => void
  SubComponent: React.FC<SubComponentProps>
}) => {
  const backgroundColor = useColorWithOpacity(styles?.backgroundColor ?? '#FFFFFF', styles?.backgroundColorOpacity)
  const borderColor = useColorWithOpacity(styles?.borderColor, styles?.borderColorOpacity)
  const [searchValue, setSearchValue] = useState('')
  const dataToUse = data.filter((x) => !searchValue || x.name.toLowerCase().includes(searchValue.toLowerCase()))
  const hasSearchBar = styles?.hasSearchBar && data.length > 0

  return (
    <Box
      w="100%"
      className="c-component-wrapper"
      bgColor={backgroundColor}
      border="1px solid transparent"
      borderColor={borderColor}
      borderRadius={`${styles?.borderRadius}px`}
      css={{
        p: mobileStyles?.padding,
        '@container page (min-width: 901px)': {
          p: styles?.padding,
        },
      }}
    >
      {(styles?.hasTitle || hasSearchBar) && (
        <Group w="100%" justifyContent="space-between" pb="12px">
          {styles?.hasTitle && <SubComponent {...rest} id={subComponents?.title} name="Title" parentId={id} />}
          {hasSearchBar && (
            <InputGroup endElement={<SearchIcon />} margin="0 0 0 auto">
              <Input
                placeholder="Search"
                size="sm"
                value={searchValue}
                onChange={(e) => {
                  setSearchValue(e.target.value)

                  if (onSearch) {
                    onSearch(e.target.value)
                  }
                }}
              />
            </InputGroup>
          )}
        </Group>
      )}
      <LeaderboardGroup data={dataToUse} styles={styles} registerUrl={registerUrl} />
    </Box>
  )
}

export default Leaderboard
